import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL,

  ACTION_LOAD_AFFILIATE_TOOLS__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS__FAIL,

  ACTION_LOAD_ROTATING_BANNER__REQUEST,
  ACTION_LOAD_ROTATING_BANNER__SUCCESS,
  ACTION_LOAD_ROTATING_BANNER__FAIL,

  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL,

  ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL,
  ACTION_ADD_PROMOTED_SITES,

  ACTION_ADD_SELECTED_PARAMS,
  ACTION_CLEAR_SELECTED_PARAMS,
} from '../actionTypes';

import customBanners from './customBanners';
import errors from './errors';


const affiliateToolsFilterStructure = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS:
      return action.payload.affiliateToolsFilterStructure;

    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL:
      return {};

    default:
      return state;
  }
};

const isAffiliateToolsFilterStructureLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST:
      return true;

    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS:
    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL:
      return false;

    default:
      return state;
  }
};

const launchAffiliateToolUrl = (state = null, action) => {
  switch (action.type) {
    case ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL:
      return action.payload.launchAffiliateToolUrl;

    default:
      return state;
  }
};

const affiliateToolsByType = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS__REQUEST:
      return {};

    case ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS: {
      const { affiliateTools, affiliateToolsType } = action.payload;

      return { ...state, [affiliateToolsType]: affiliateTools };
    }

    default:
      return state;
  }
};

const affiliateToolsOrderByType = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS__REQUEST:
      return {};

    case ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS: {
      const { affiliateToolsOrder, affiliateToolsType } = action.payload;

      return { ...state, [affiliateToolsType]: affiliateToolsOrder };
    }

    default:
      return state;
  }
};

const isAffiliateToolsLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS__REQUEST:
      return true;

    case ACTION_LOAD_AFFILIATE_TOOLS__FAIL:
    case ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS:
      return false;

    default:
      return state;
  }
};

const requestStartTime = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS__REQUEST:
      return action.payload.startTime;

    default:
      return state;
  }
};

const promotedSites = (state = false, action) => {
  switch (action.type) {
    case ACTION_ADD_PROMOTED_SITES:
      return action.payload.promotedSites;

    default:
      return state;
  }
};

const rotatingBanner = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_ROTATING_BANNER__REQUEST:
    case ACTION_LOAD_ROTATING_BANNER__FAIL:
      return null;

    case ACTION_LOAD_ROTATING_BANNER__SUCCESS:
      return action.payload.rotatingBanner;

    default:
      return state;
  }
};

const affiliateToolContentById = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST:
    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL:
      return _omit(state, action.payload.id);

    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS: {
      const { id, content } = action.payload;

      return { ...state, [id]: content };
    }

    default:
      return state;
  }
};

const selectedParams = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SELECTED_PARAMS:
      return { ...state, ...action.payload.selectedParams };

    case ACTION_CLEAR_SELECTED_PARAMS:
      return _omit(state, action.payload.selectedParamNames);

    default:
      return state;
  }
};

export default combineReducers({
  promotedSites,
  affiliateToolsByType,
  affiliateToolsOrderByType,
  affiliateToolsFilterStructure,
  affiliateToolContentById,
  customBanners,
  errors,
  isAffiliateToolsFilterStructureLoading,
  isAffiliateToolsLoading,
  requestStartTime,
  launchAffiliateToolUrl,
  rotatingBanner,
  selectedParams,
});
